<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "FangCustomer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FangCustomer.vue